import { render, staticRenderFns } from "./KitsDinamicos.vue?vue&type=template&id=5a64e1af"
import script from "./KitsDinamicos.vue?vue&type=script&lang=ts"
export * from "./KitsDinamicos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports